<div class="profile-detail-container">
  <div fxLayout>
    <div fxFlex="75">
      <ngx-skeleton-loader
        appearance="circle"
        [theme]="{
          width: '60px',
          height: '60px'
        }"
      >
      </ngx-skeleton-loader>
    </div>
    <div  class="edit-button-container">
      <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
    </div>
  </div>
  <div fxLayout>
    <div fxFlex="75" >
      <div  class="driver-name">
        <ngx-skeleton-loader
          appearance="line"
          [theme]="{
            width: '30%',
            height: '10px'
          }"
        ></ngx-skeleton-loader>
      </div>
      <div  class="driver-email">
        <ngx-skeleton-loader appearance="line" [theme]="{ width: '70%', height: '10px' }"></ngx-skeleton-loader>
      </div>
    </div>
    <div  class="driver-id-container">
      <div  class="driver-id">
        <ngx-skeleton-loader appearance="line" [theme]="{ height: '20px' }"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
<mat-divider></mat-divider>
<div class="profile-completion" >
  <div >
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        width: '60%',
        height: '10px'
      }"
    ></ngx-skeleton-loader>
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        width: '90%',
        height: '14px'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div  class="completion-circle">
    <ngx-skeleton-loader
      appearance="circle"
      [theme]="{
        width: '55px',
        height: '55px'
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
